import type { Translations } from "../types";

const tl: Translations = {
  "meta.title": "Mapa ng mga Click ayon sa Bansa",
  "meta.description":
    "Interactive na mapa ng mundo: libreng click para sa bawat bansa kasama ang bayad na suporta sa pamamagitan ng Stripe, PayPal, at Buy Me a Coffee.",

  "app.title": "Mapa ng mga Click ayon sa Bansa",

  "map.intro":
    "I-click ang isang bansa sa mapa para bigyan ito ng libreng boto, o magpadala ng suportang pinansyal - pareho itong may bahagi sa kumbinadong leaderboard sa ibaba. Ipinapakita ng mapa ang suporta lamang sa loob ng app na ito, hindi ang aktwal na yaman ng bansa o GDP.",
  "map.verifying": "Bineberipika …",
  "map.confirmNotRobot": "Bago ka makapagdagdag ng libreng click, mabilis na kumpirmahin na hindi ka robot:",
  "map.tryAgain": "Subukan ulit",
  "map.registeringClick": "Isinasagawa ang click …",
  "map.selectedCountry": "Napiling bansa: {name}.",
  "map.selectFirstFeedback": "Napili na ang bansa. Para magdagdag ng libreng click, kumpirmahin muna sa ibaba na hindi ka robot.",
  "map.verificationExpired": "Nag-expire ang beripikasyon - kumpirmahin ulit na hindi ka robot.",
  "map.slowDown": "Bagalan nang kaunti - maghintay muna bago mag-click ulit.",
  "map.clickFailed": "Hindi na-register ang click. Pakisubukan ulit.",
  "map.clickErrorGeneric": "May error sa pag-register ng click.",
  "map.leaderboardHeading": "Leaderboard ng mga Bansa",
  "map.emptySelection": "Pumili ng bansa sa mapa para i-click o suportahan ito.",
  "map.loadingData": "Nilo-load ang datos …",

  "worldmap.loadError": "Hindi ma-load ang mapa.",
  "worldmap.resetZoom": "I-reset ang zoom",
  "worldmap.resetButton": "⤾ I-reset",
  "worldmap.loadingMap": "Nilo-load ang mapa …",
  "worldmap.unknownCountry": "Hindi Kilala",
  "worldmap.ariaClicks": "{name}: {clicks} na click",
  "worldmap.tooltipClicks": "{clicks} na click",

  "legend.fewer": "Mas kaunting click",
  "legend.more": "Mas maraming click",

  "list.empty": "Wala pang click. Ikaw na ang una!",
  "list.ariaLabel": "Leaderboard ng mga bansa ayon sa click",

  "human.siteKeyMissing": "Hindi naka-set ang VITE_TURNSTILE_SITE_KEY - tingnan ang README para sa configuration.",
  "human.verificationFailedGeneric": "Nabigo ang beripikasyon.",
  "human.networkError":
    "Hindi maabot ang beripikasyon (network error) - suriin ang VITE_SUPABASE_URL, kung naka-deploy ang verify-human, at ang ALLOWED_ORIGIN; tingnan ang README/NAVODILA.",
  "human.verificationFailedRetry": "Nabigo ang beripikasyon, subukan ulit.",

  "provider.stripe": "💳 Card (Stripe)",
  "provider.paypal": "🅿️ PayPal",
  "provider.buymeacoffee": "☕ Buy Me a Coffee",

  "panel.selectedCountryLabel": "Napiling bansa",
  "panel.currentlyRanked": "Kasalukuyang nasa ranggong #{rank}",
  "panel.shareCopied": "Nakopya ✓",
  "panel.shareShared": "Na-share ✓",
  "panel.shareButton": "🔗 I-share",

  "panel.tableClicks": "Mga Click",
  "panel.tableFree": "Libre",
  "panel.tablePaid": "Bayad",
  "panel.rowAllTime": "Sa kabuuan",
  "panel.rowThisYear": "Ngayong taon",
  "panel.rowThisWeek": "Ngayong linggo",
  "panel.rowToday": "Ngayon",

  "panel.totalCombined": "Kabuuang kumbinado:",
  "panel.totalSupport": "Kabuuang suporta:",

  "panel.paymentMethod": "Paraan ng pagbabayad",
  "panel.noPaymentMethod": "Walang available na paraan ng pagbabayad sa ngayon.",
  "panel.supportAmount": "Halaga ng suporta (EUR)",
  "panel.amountRange": "Dapat nasa pagitan ng {min} at {max} ang halaga.",
  "panel.quickAmount": "€{eur}",
  "panel.estimatedClicks": "Tinatayang bayad na click:",
  "panel.ratioInfo":
    "Ratio: {a} = {b} na click (hal. {c} = {d} na click). Tantiya lang ito bago ang bayad - ang huling bilang ng click ay palaging kinakalkula at kinukumpirma ng server batay sa aktwal na nakumpirmang bayad.",
  "panel.preparing": "Inihahanda …",
  "panel.continueWith": "Magpatuloy gamit ang {provider}",
  "panel.choosePaymentMethod": "Pumili ng paraan ng pagbabayad",
  "panel.bmcUsernameMissing": "Hindi naka-set ang VITE_BMC_USERNAME - tingnan ang README para sa configuration.",
  "panel.paypalClientIdMissing": "Hindi naka-set ang VITE_PAYPAL_CLIENT_ID - tingnan ang README para sa configuration.",

  "panel.paypalAmountInfo": "Halaga: {amount} (tinatayang {clicks} na click). Kumpletuhin ang bayad gamit ang PayPal button sa ibaba.",
  "panel.back": "← Bumalik",

  "panel.bmcWarningTitle": "⚠️ Bago magpatuloy sa BuyMeCoffee:",
  "panel.bmcWarningBody":
    "I-paste ang code sa ibaba sa message/note field sa checkout — iyon lang ang paraan para malaman namin kung aling bansa ang sinusuportahan mo. Kung walang code, hindi namin maiuugnay ang bayad sa anumang bansa.",
  "panel.copy": "Kopyahin",
  "panel.copied": "Nakopya ✓",
  "panel.suggestedAmount": "Iminumungkahing halaga:",
  "panel.bmcAmountNote":
    "(tinatayang {clicks} na click). Sa kasamaang-palad, hindi suportado ng BuyMeCoffee ang pagdadala ng halaga sa pamamagitan ng link — ipasok/piliin ito mismo sa kanilang site. Ang aktwal na bilang ng click ay palaging kinakalkula batay sa halagang aktwal mong ipinadala sa BuyMeCoffee, hindi sa tantiyang ito.",
  "panel.openBmc": "Buksan ang BuyMeCoffee at magpatuloy →",
  "panel.waitingProvider": "Hinihintay ang kumpirmasyon ng bayad mula sa payment provider …",
  "panel.waitingConfirmation": "Hinihintay ang kumpirmasyon ng bayad …",
  "panel.timedOut":
    "Nag-timeout ang pagche-check. Kung nakumpleto mo na ang bayad, ma-a-update ang mapa kapag natanggap na ng server ang kumpirmasyon - minsan nangangailangan ito ng kaunting karagdagang oras.",
  "panel.checkAgain": "Tignan ulit",

  "panel.cancelled": "Kinansela o hindi natuloy ang bayad. Walang pagbabago sa mapa.",
  "panel.tryAgain": "Subukan ulit",

  "panel.confirmed": "✅ Nakumpirma ang suporta!",
  "panel.confirmedBody": "Nakatanggap ang {country} ng {clicks} bayad na click para sa {amount}.",

  "panel.errorPreparingSupport": "May error sa paghahanda ng iyong suporta.",
  "panel.errorPreparingPayment": "May error sa paghahanda ng bayad.",
  "panel.errorConfirmingPayment": "May error sa pagkumpirma ng bayad.",
  "panel.errorPayingPaypal": "May error sa pagbabayad gamit ang PayPal.",

  "share.unranked": "{flag}{country} ay nangangailangan ng suporta mo sa mapa ng mundo!\nTulungan itong umakyat sa leaderboard 👇",
  "share.rank1": "{flag}{country} ay kasalukuyang #1!\nTulungan kaming manatili sa tuktok 👇",
  "share.rankN": "{flag}{country} ay kasalukuyang #{rank}!\nTulungan kaming maabot ang #1 👇",

  "language.switcherLabel": "Wika",
};

export default tl;
